"use strict";
/**
 * fetchJsonp
 *
 * ### Example
 * ```
 * fetchJsonp('/test').then(response => {
 *     console.log(response);
 * }).catch(error => {
 *     console.log(error);
 * });
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
var jsonpCallback = 'callback';
function fetchJsonp(url) {
    var timeoutId;
    return new Promise(function (resolve, reject) {
        var callbackFn = generateCallbackFn();
        var scriptId = jsonpCallback + "_" + callbackFn;
        window[callbackFn] = function (response) {
            resolve(response);
            timeoutId && clearTimeout(timeoutId);
            finish(scriptId, callbackFn);
        };
        url += url.indexOf('?') === -1 ? '?' : '&';
        var script = document.createElement('script');
        script.setAttribute('src', "" + url + jsonpCallback + "=" + callbackFn);
        script.id = scriptId;
        document.head.appendChild(script);
        timeoutId = setTimeout(function () {
            reject(new Error("JSONP time out"));
            finish(scriptId, callbackFn);
        }, 8000);
    });
}
exports.fetchJsonp = fetchJsonp;
function generateCallbackFn() {
    return "jsonp_" + Date.now() + "_" + Math.ceil(Math.random() * 100000);
}
function finish(scriptId, functionName) {
    document.head.removeChild(document.getElementById(scriptId));
    try {
        delete window[functionName];
    }
    catch (e) {
        window[functionName] = void 0;
    }
}
